import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type HeroSectionProps = {
  guaranteeEnabled: boolean;
};
export function HeroSection({
  guaranteeEnabled
}: HeroSectionProps) {
  return <header className="bg-blue-950 px-4 pb-6 pt-5 text-center md:px-10 md:pb-7 md:pt-6" data-id="element-99" data-mp="28u4ncn43lelf">
      <p className="text-[13px] font-extrabold uppercase tracking-[0.08em] text-teal-300 md:text-[15px]" data-id="element-100" data-mp="28vza86yxjgs5">
        Complete Postoperative Shoulder Rehabilitation System™
      </p>
      <h1 className="mt-1.5 text-[24px] font-extrabold uppercase leading-[1.08] tracking-[-0.3px] text-white md:text-[34px]" data-id="element-101" data-mp="30kj20ljxquy5">
        The complete postoperative shoulder rehabilitation system for{' '}
        <span className="text-teal-300" data-id="element-102" data-mp="2rqw6mwjn3tph">physical therapists</span>
      </h1>
      <p className="mx-auto mt-3 max-w-[580px] text-[14px] leading-[1.45] text-white md:text-[16px]" data-id="element-103" data-mp="3fht9zkxddip4">
        Procedure-specific protocols, fully developed therapeutic exercises, postoperative precautions, strength
        progressions, and clinical decision-making tools — in one advanced professional collection.
      </p>
      <p className="mx-auto mt-2.5 max-w-[560px] text-[13px] font-extrabold uppercase leading-tight text-amber-400 md:text-[15px]" data-id="element-104" data-mp="2bbu4rc0xie5b">
        Different surgeries. Different restrictions. One organized system for every rehabilitation plan.
      </p>

      <div className="mx-auto mt-3 max-w-[340px]" data-id="element-105" data-mp="2z2q18mgbxxiw">
        <ProductImage data-id="element-106" data-mp="2z5lzyd004q8e" />
      </div>

      <h2 className="mx-auto mt-2 max-w-[520px] text-[16px] font-extrabold uppercase leading-snug text-white md:text-[19px]" data-id="element-107" data-mp="2u4y1555j753m">
        Complete Postoperative Shoulder Rehabilitation System™
      </h2>
      <p className="mt-1 text-[13px] font-extrabold uppercase leading-tight text-teal-300 md:text-[15px]" data-id="element-108" data-mp="334l4hwhtmkzb">
        7 Advanced Clinical Volumes + 5 FREE Professional Bonuses
      </p>

      <div className="mt-3.5" data-id="element-109" data-mp="18rbp5o2lg595">
        <CtaButton mode="scroll" subtext="Get access to organized resources for postoperative shoulder rehabilitation" data-id="element-110" data-mp="18s50z3getky5">
          Yes! I want the complete rehabilitation system!
        </CtaButton>
      </div>
      <p className="mx-auto mt-3 max-w-[440px] text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-111" data-mp="3dt7crm99rq1f">
        {guaranteeEnabled && <>
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-112" data-mp="3mtm0stdmbj8m" />
            7-day money-back guarantee •{' '}
          </>}
        7 volumes + 5 FREE bonuses
      </p>
    </header>;
}